import { TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import FieldFormControl from '../FieldFormControl';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { NumericFormat } from 'react-number-format';

const NumericField = ({ field, disabled }) => {
	const { getFieldProps, setFieldValue, getFieldHelpers, getFieldMeta } = useFormikContext();

	const { field: fieldConfig } = field;
	const validation = fieldConfig.validation;

	const { onBlur: onFieldBlur, onChange, ...fieldProps } = getFieldProps(field.name);

	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	return (
		<NumericFormat
			id={field.name}
			fullWidth
			customInput={TextField}
			decimalScale={validation === 'currency' ? 2 : 0}
			fixedDecimalScale
			{...(validation !== 'phone' && {
				thousandSeparator: true,
			})}
			{...(validation === 'currency' && {
				prefix: '$',
			})}
			allowNegative={false}
			allowLeadingZeros={validation === 'phone'}
			onValueChange={({ value, floatValue }) => {
				setFieldValue(field.name, validation === 'currency' ? floatValue : value);
			}}
			{...fieldProps}
			{...{ onBlur, error, disabled }}
		/>
	);
};
const FormikTextField = ({ field, labelStyle, disabled }) => {
	const formik = useFormikContext();
	const { isProspect } = useClientSchemaContext();
	const { setFieldValue, getFieldProps, getFieldMeta, getFieldHelpers, values } = formik;

	const { field: fieldConfig } = field;

	const validation = fieldConfig.validation;

	const [name, setName] = useState(values[field.name] ?? '');

	useEffect(() => {
		setName(values[field.name] ?? '');
	}, [values[field.name]]);

	const { onBlur: onFieldBlur, ...fieldProps } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);
	const required = field.mandatory[isProspect ? 'prospect' : 'client'];

	return (
		<FieldFormControl {...{ field, currentValue: name, disabled, labelStyle }}>
			{['number', 'currency'].includes(validation) ? (
				<NumericField {...{ field, disabled }} />
			) : (
				<TextField
					id={field.name}
					fullWidth
					{...fieldProps}
					{...{ disabled, error, required }}
					{...(fieldConfig.rows && {
						rows: fieldConfig.rows,
						multiline: true,
					})}
					value={name}
					onChange={(e) => setName(e.target.value)}
					slotProps={{
						htmlInput: {
							...(fieldConfig.max && { maxLength: fieldConfig.max }),
						},
					}}
					onBlur={async (e) => {
						setFieldValue(field.name, name.trim());
						setName((prev) => prev.trim());
						setTimeout(() => {
							onBlur(e);
						}, 100);
					}}
				/>
			)}
		</FieldFormControl>
	);
};

export default FormikTextField;
